import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export interface FormSectionProps extends ChakraV3.StackProps {
  heading?: string | React.ReactElement;
  description?: string | React.ReactElement;
  extra?: string | React.ReactElement;
  layout?: 'vertical' | 'horizontal';
}

export const FormSection = (props: React.PropsWithChildren<FormSectionProps>) => {
  const { heading, description, extra, layout, children, ...rest } = props;

  const stackProps: Partial<ChakraV3.StackProps> = {
    direction: layout === 'horizontal' ? 'row' : 'column',
    align: layout === 'horizontal' ? 'center' : undefined,
    gap: 6,
  };

  return (
    <ChakraV3.Box w='full'>
      <ChakraV3.Stack gap={1} mb={4}>
        <ChakraV3.HStack>
          {heading && (
            <ChakraV3.Box fontSize='md' fontWeight='bold'>
              {heading}
            </ChakraV3.Box>
          )}
          <ChakraV3.Spacer />
          {extra && <ChakraV3.Box>{extra}</ChakraV3.Box>}
        </ChakraV3.HStack>
        {description && (
          <ChakraV3.Box fontSize='sm' color='secondary'>
            {description}
          </ChakraV3.Box>
        )}
      </ChakraV3.Stack>
      <ChakraV3.Stack {...stackProps} {...rest}>
        {children}
      </ChakraV3.Stack>
    </ChakraV3.Box>
  );
};
